// extracted by mini-css-extract-plugin
export default {"string-list__pipe":"StringList_string-list__pipe__dNwe2","string-list--block":"StringList_string-list--block__DbyTc"};